module.exports = __webpack_public_path__ + "img/coach-3.314395ec.jpg";